<template>
	<div>
		<b-row>
			<b-col sm="12" :md="4" :lg="4" :xl="4">
				<b-form-group :label="FormMSG(53, 'Equipment')">
					<b-form-select
						v-model="$v.dataToSend.type.$model"
						:options="technicalProductionOptions"
						:placeholder="FormMSG(52, 'Please select')"
						:disabled="disableAll"
						:state="!$v.dataToSend.type.$invalid || $v.dataToSend.type.$dirty ? !$v.dataToSend.type.$invalid : null"
						@change="handleChangeType"
					/>
				</b-form-group>
			</b-col>
			<b-col sm="12" :md="4" :lg="4" :xl="4">
				<b-form-group v-if="[1, 2, 3, 4].includes(dataToSend.type)" :label="FormMSG(16, 'Reporting type')">
					<b-form-select
						v-model="$v.dataToSend.subType.$model"
						:options="reportingTypeOptions"
						:placeholder="FormMSG(52, 'Please select')"
						:disabled="disableAll"
						:state="!$v.dataToSend.subType.$invalid || $v.dataToSend.subType.$dirty ? !$v.dataToSend.subType.$invalid : null"
						@change="handleChangeSubType"
					/>
				</b-form-group>
			</b-col>
		</b-row>
		<b-row v-if="isEquipmentTypeWithSubType">
			<b-col sm="12" :md="4" :lg="4" :xl="4">
				<b-form-group>
					<label class="d-flex align-items-center"
						>{{ FormMSG(17, 'Size') }}
						<button id="popover-details-carbon" class="btn-transparent text-color-blue-streak">
							<component :is="getLucideIcon('Info')" :size="16" />
						</button>
						<b-popover :target="`popover-details-carbon`" triggers="hover">
							<template #title>
								<div>
									<component :is="getLucideIcon('Info')" :size="16" color="#225cbd" />
									{{ FormMSG(1547, 'Information') }}
								</div>
							</template>
							<div class="d-flex flex-column">
								<span class="pb-1">The size is a criteria set by Carbon Clap by Ecoprod.</span>
								<span class="py-1"
									><strong>Small</strong> - Video clip, low-budget documentary, news report, corporate film or short film
								</span>
								<span class="py-1"><strong>Medium</strong> - Low-budget drama, TV film, big-budget documentary or customer advertising </span>
								<span class="py-1"><strong>Large</strong> - Big-budget drama or luxury advertising </span>
							</div>
						</b-popover>
					</label>
					<b-form-select
						v-model="$v.dataToSend.additionalSubType.$model"
						:options="sizeOptions"
						:placeholder="FormMSG(52, 'Please select')"
						:disabled="disableAll"
						:state="
							!$v.dataToSend.additionalSubType.$invalid || $v.dataToSend.additionalSubType.$dirty
								? !$v.dataToSend.additionalSubType.$invalid
								: null
						"
						@change="handleChangeType"
					/>
				</b-form-group>
			</b-col>
			<b-col sm="12" :md="4" :lg="4" :xl="4">
				<b-form-group :label="FormMSG(18, 'Day used')">
					<b-form-input
						v-model="$v.dataToSend.daysUsed.$model"
						:placeholder="FormMSG(18, 'Day used')"
						:state="!$v.dataToSend.daysUsed.$invalid || $v.dataToSend.daysUsed.$dirty ? !$v.dataToSend.daysUsed.$invalid : null"
						@change="handleChangeType"
					/>
				</b-form-group>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import _ from 'lodash';
import { minValue } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import globalMixin from '@/mixins/global.mixin';

export default {
	name: 'CoTwoTehnicalProductionForm',

	mixins: [languageMessages, validationMixin, globalMixin],

	props: {
		coTwoData: { type: Object, required: true },
		forCarbonTemplate: { type: Boolean, default: false, required: false },
		disableAll: { type: Boolean, default: false, required: false }
	},

	data() {
		return {
			dataToSend: {
				type: 0,
				subType: 0,
				additionalSubType: 0,
				daysUsed: 0
			}
		};
	},

	computed: {
		technicalProductionOptions() {
			const menu = [{ value: 0, text: this.FormMSG(52, 'Please select') }, ...this.FormMenu(11010)];
			return menu;
		},
		reportingTypeOptions() {
			const menu = [{ value: 0, text: this.FormMSG(52, 'Please select') }, ...this.FormMenu(40150)];
			console.log('menu', menu);
			return menu;
		},
		sizeOptions() {
			const menu = [{ value: 0, text: this.FormMSG(52, 'Please select') }, ...this.FormMenu(40151)];
			return menu;
		},
		isEquipmentType() {
			return [1, 2, 3, 4].includes(this.dataToSend.type);
		},
		isEquipmentTypeWithSubType() {
			return this.isEquipmentType && this.dataToSend.subType === 1;
		}
	},

	watch: {
		coTwoData: {
			handler(newVal) {
				if (JSON.stringify(newVal) && !_.isNil(newVal)) {
					this.dataToSend = {
						...this.dataToSend,
						type: newVal.type,
						subType: newVal.subType,
						additionalSubType: newVal.additionalSubType,
						daysUsed: +newVal.daysUsed
					};
				}
			},
			immediate: true,
			deep: true
		}
	},

	methods: {
		isInvalid() {
			this.$v.$touch();

			return this.$v.$invalid;
		},
		handleChangeType() {
			this.emitChange();
		},
		handleChangeSubType() {
			if (this.dataToSend.subType === 2) {
				this.dataToSend = {
					...this.dataToSend,
					additionalSubType: 0,
					daysUsed: 0
				};
			}
			this.emitChange();
		},
		emitChange() {
			this.$v.$touch();

			this.dataToSend = {
				...this.dataToSend,
				daysUsed: +this.dataToSend.daysUsed
			};
			this.$emit('co-two-tehnical-production:change', this.dataToSend);
		}
	},

	validations() {
		return {
			dataToSend: {
				type: { minValue: minValue(1) },
				subType: this.isEquipmentType ? { minValue: minValue(1) } : {},
				additionalSubType: this.isEquipmentTypeWithSubType ? { minValue: minValue(1) } : {},
				daysUsed: this.isEquipmentTypeWithSubType ? { minValue: minValue(1) } : {}
			}
		};
	}
};
</script>

<style scoped></style>
